/** Types */
import { ParamsFromObjectType } from '../types/byd-params-from-object.type';

/**
 * @param httpParamValue the http params httpParamValue
 * @returns true if the http param is valid
 */
export function BydIsHttpParam(httpParamValue: ParamsFromObjectType): boolean {
  return !(
    (!httpParamValue && httpParamValue !== 0 && httpParamValue !== false) ||
    httpParamValue === '[]' ||
    (Array.isArray(httpParamValue) && !httpParamValue.length)
  );
}
